import React, { Component } from 'react';
import { CommonlyHead } from '../common/headnav';
import { Toast } from 'antd-mobile';
import * as services from '../projects/services';
import { Customgy } from "../common/customgy";
import '../package/style.less'
export default class Custom extends Component {
    constructor(props) {
        super(props);
        this.state =
        {
            mcno: this.props.match.params.mcno,
            packageid: this.props.match.params.packageid,
            checkItem: [],
            TabTitle: [],
            TabItem: [],
            cardid: 0,
            gender: this.props.match.params.gender,

        }
    }
    componentDidMount() {

        if (!!localStorage.getItem('orderment') === true) {
            let orderment = JSON.parse(localStorage.getItem('orderment'));
            this.setState({ cardid: orderment.cardid, gender: orderment.gender });
        }
        let parameter = { McNO: this.state.mcno, peopleId: null }
        services.GetListbyitem(parameter, '正在查询，请稍后').then(value => {
            if (value.status === 0) {
                let TabTitle = [];
                let TabItem = [];
                //获取当前套餐项目
                services.Getpackbyitem(this.state.packageid, '').then(value2 => {
                    if (value2.status === 0) {
                        let data = value2.result;
                        value.result.forEach((element, index) => {
                            let cm = element.children;
                            element.children = element.children.filter(item => item.gender === 0 || item.gender === parseInt(this.state.gender));
                            TabTitle.push({ name: element.shortname, title: element.shortname + '(' + element.children.length + ')', key: 't' + element.itemtypeid, id: index, num: element.children.length });
                            cm.forEach((val) => {
                                val['checked'] = 0;
                                data.forEach((val2) => {
                                    if (val.itemid === val2.itemid) {
                                        if (val2.chooseid === 1) {
                                            val['checked'] = 2;

                                        } else {
                                            val['checked'] = 1;
                                        }
                                    }
                                })
                            })
                            cm.forEach((val, cindex) => {
                                if (val.bindChildren.length > 0) {
                                    val.bindChildren.forEach((data3) => {
                                        if (data3.bindId === 0) {
                                            data3.mid = cm[cindex].itemid;
                                            data3.mname = cm[cindex].itemname;
                                        }
                                        if (val.checked === 1) {
                                            if (data3.bindId === 1) {
                                                let c = cm.find((element) => element.itemid === data3.bindItemId);
                                                if (c !== undefined) {
                                                    c.checked = 3;
                                                }
                                            }
                                        }
                                    })
                                }
                            })
                        });

                        TabItem = value.result;
                   
                        this.setState({ TabTitle: TabTitle, TabItem: TabItem, checkItem: value2.result }, () => {
                        });


                    } else {
                        Toast.offline(value2.message);
                    }

                })

            } else {
                Toast.offline(value.message);
            }
        })
    }
    render() {
        const { TabTitle, TabItem, checkItem } = this.state;
        return <div className="custom">   <CommonlyHead barname={'自定义套餐'} />
            {
                TabItem.length === 0 ? '' :

                    <Customgy TabTitle={TabTitle} TabItem={TabItem} checkItem={checkItem} cardid={this.state.cardid} mcno={this.state.mcno} packageid={this.state.packageid} />
            }</div>;
    }

}